<template>
  <div
    v-if="!props.image"
    class="flex flex-col items-center justify-center gap-1 h-full w-full bg-secondary-100"
    :class="getRoundedClass(props.format)">
    <FolderUp class="text-red-600 h-7 w-7" />
    <span dir="rtl" class="text-secondary-975 text-xs">
      {{ t('blocksSettings.pairing.empty_image') }}
    </span>
    <span class="text-secondary-600 text-xs">
      {{ t('blocksSettings.pairing.need_image') }}
    </span>
  </div>
  <img v-else :src="props.image" :class="getImageClass(props.format)" />
</template>

<script setup lang="ts">
import { PairingItemFormat } from '@amit/types';
import { PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import { FolderUp } from 'lucide-vue-next';

const { t } = useI18n();

const props = defineProps({
  format: {
    type: String as PropType<PairingItemFormat>,
    default: PairingItemFormat.TextImage,
  },
  image: {
    type: String,
    default: '',
  },
});

const getImageClass = (format: PairingItemFormat) => {
  const itemClass = ['w-full object-cover p-0.5'];
  if (format.includes('text')) {
    itemClass.push('h-[77px]');
  } else {
    itemClass.push('h-full rounded-md');
  }
  if (format === PairingItemFormat.ImageText) {
    itemClass.push('rounded-t-md');
  } else {
    itemClass.push('rounded-b-md');
  }
  return itemClass;
};

const getRoundedClass = (format: PairingItemFormat) => {
  if (!format.includes('text')) return 'rounded-md';
  if (format === PairingItemFormat.ImageText) {
    return 'rounded-t-md';
  } else {
    return 'rounded-b-md';
  }
};
</script>
